var _defs, _circle, _ellipse, _ellipse2, _ellipse3, _ellipse4, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3, _path4, _polygon5, _polygon6, _polygon7, _polygon8, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse5, _path11, _ellipse6, _path12, _circle2, _circle3, _ellipse7, _circle4, _ellipse8, _ellipse9, _ellipse10, _ellipse11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApiPlatform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#abe1e1;}.b,.c{fill:#1d1e1c;}.b{opacity:0.2;}.d{fill:#38a9b4;}.e{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 600,
    cy: 600,
    r: 600
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 428.08,
    cy: 768.44,
    rx: 79.63,
    ry: 20.09
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 263.32,
    cy: 764.08,
    rx: 79.63,
    ry: 20.09
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 302.5,
    cy: 882.57,
    rx: 79.63,
    ry: 20.09
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 151.32,
    cy: 825.99,
    rx: 79.63,
    ry: 20.09
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "341.12 757.99 326.57 757.99 326.57 438.14 467.73 514.14 460.83 526.95 341.12 462.5 341.12 757.99"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "230.55 821.15 216.12 819.32 256.33 501.36 469.78 533.42 467.62 547.8 268.9 517.96 230.55 821.15"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "365.9 865.82 359.01 577.81 462.25 547.85 466.31 561.82 373.82 588.66 380.45 865.47 365.9 865.82"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "481.21 745.01 433.6 602.18 500.87 586.11 504.25 600.26 452.42 612.64 495.01 740.41 481.21 745.01"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M482.29,743.44s-14-24-35.38-8.73-9,36.37-9,36.37,7,6.54,30.78,7.27,29.4,0,33.86-5.09S492.47,730,492.47,730Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M209.36,796.36s-22.43-33.4-52.14-12.15-12.51,50.61-12.51,50.61,9.72,7.18,42.82,7.21c43.07.05,42.22-12.88,45.26-21.79,5.09-15-10.72-42.56-10.72-42.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M324.49,743.1s-29.7-42.13-59.42-20.87-12.51,50.6-12.51,50.6,9.73,7.18,42.83,7.22c43.07,0,45.13-8.52,48.16-17.44,5.09-15-13.62-46.91-13.62-46.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M364.49,856.51s-26.78-40.68-56.5-19.42-12.51,50.6-12.51,50.6,9.73,8.63,42.83,8.67c43.06,0,43.64-13.83,43.79-23.25.74-46-15.07-42.55-15.07-42.55Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "857.49 759.92 872.04 759.92 872.04 440.07 730.89 516.08 737.78 528.89 857.49 464.43 857.49 759.92"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "968.06 823.08 982.5 821.26 942.28 503.3 728.84 535.35 731 549.74 929.72 519.89 968.06 823.08"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "832.71 867.75 839.6 579.74 736.36 549.78 732.31 563.75 824.79 590.59 818.16 867.4 832.71 867.75"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "717.41 746.94 765.02 604.11 697.74 588.04 694.36 602.19 746.19 614.58 703.6 742.34 717.41 746.94"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M716.32,745.37s14-24,35.39-8.73,9,36.37,9,36.37-7,6.55-30.78,7.28-29.4,0-33.87-5.1S706.14,732,706.14,732Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M989.25,798.29s22.43-33.4,52.15-12.14,12.51,50.6,12.51,50.6-9.73,7.18-42.83,7.22c-43.07,0-42.22-12.88-45.25-21.8-5.09-15,10.71-42.55,10.71-42.55Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M874.13,745s29.69-42.13,59.41-20.88,12.51,50.61,12.51,50.61-9.73,7.17-42.83,7.21c-43.06,0-45.12-8.51-48.16-17.43-5.09-15,13.63-46.92,13.63-46.92Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M834.12,858.44s26.79-40.67,56.5-19.42,12.51,50.61,12.51,50.61-9.72,8.63-42.82,8.67c-43.07,0-43.65-13.84-43.8-23.26-.73-46,15.08-42.55,15.08-42.55Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M761.6,493.81c0,87.82-70,134.27-156.39,134.27s-152-46.45-152-134.27,65.65-118.26,152-118.26S761.6,406,761.6,493.81Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M603.3,635.36c-45.68,0-84.78-12.41-113-35.89C460,574.35,444,537.82,444,493.81c0-82.13,55.08-125.54,159.3-125.54C708.84,368.27,767,412.86,767,493.81c0,43.84-16.79,80.4-48.54,105.75C689.51,622.64,648.62,635.36,603.3,635.36Zm0-252.54c-96,0-144.75,37.34-144.75,111,0,78.34,55.46,127,144.75,127,90.59,0,149.12-49.85,149.12-127C752.42,402.08,671.33,382.82,603.3,382.82Z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 546.29,
    cy: 400.56,
    rx: 97.47,
    ry: 100.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M544.38,506.45c-56.55,0-102.56-47.5-102.56-105.89s46-105.89,102.56-105.89S647,342.17,647,400.56,600.94,506.45,544.38,506.45Zm0-201.59c-50.94,0-92.38,42.93-92.38,95.7s41.44,95.71,92.38,95.71,92.38-42.93,92.38-95.71S595.32,304.86,544.38,304.86Z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 691.9,
    cy: 417.01,
    rx: 80.41,
    ry: 78.86
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M690,501c-47.15,0-85.51-37.67-85.51-84s38.36-84,85.51-84,85.51,37.67,85.51,84S737.15,501,690,501Zm0-157.73c-41.53,0-75.32,33.09-75.32,73.77s33.79,73.77,75.32,73.77,75.32-33.09,75.32-73.77S731.53,343.24,690,343.24Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 552.6,
    cy: 405.88,
    r: 44.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 576.67,
    cy: 399.05,
    r: 12.37
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 698.35,
    cy: 421.68,
    rx: 36.39,
    ry: 34.92
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 691.33,
    cy: 415.45,
    r: 10.01
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 771.92,
    cy: 771.11,
    rx: 79.63,
    ry: 20.09
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 936.68,
    cy: 766.75,
    rx: 79.63,
    ry: 20.09
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 897.5,
    cy: 885.24,
    rx: 79.63,
    ry: 20.09
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1048.68,
    cy: 828.66,
    rx: 79.63,
    ry: 20.09
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiPlatform);
export default __webpack_public_path__ + "static/media/apiPlatform.c0145df1134ad14972a7fe3c2aa60deb.svg";
export { ForwardRef as ReactComponent };